module.exports = __webpack_public_path__ + "img/white_paper9.a728780a.png";